<template>
  <a class="col-12 col-sm-6 mb-2">
    <img class="img-fluid" ref="img" :src="src">
  </a>
</template>

<script>
import util from 'util/common'
export default {
  props: ['image', 'src'],

  mounted () {
    this.showImage()
  },

  methods: {
    showImage () {
      if (!this.image) {
        return
      }
      if (util.isFile(this.image)) {
        var fr = new FileReader()
        var vm = this
        fr.onload = function (e) {
          vm.$refs.img.src = e.target.result
        }
        fr.readAsDataURL(this.image)
      } else {
        this.$refs.img.src = this.image
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ImageItem.vue?3cba2db4